import {scheduleDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useVisibilityStyles} from '../../../../hooks/use-visibility-styles'
import {useWidgetProps} from '../../../hooks/widget-props'
import {PersonalAgendaHeader} from '../personal-agenda-header'
import {ScheduleTitle} from '../schedule-title'
import {MobileHeaderProps} from './interfaces'
import s from './mobile-header.scss'

export const MobileHeader = ({alignmentClass}: MobileHeaderProps) => {
  const {eventTitle, formattedEventDateAndLocation, installedApps, personalAgendaEnabled} = useWidgetProps()
  const {
    allBreakpoints: {isDateAndLocationVisible},
  } = useVisibilityStyles()

  return (
    <div className={alignmentClass}>
      {personalAgendaEnabled ? (
        <PersonalAgendaHeader membersAreaInstalled={installedApps.eventsInMembersInstalled} />
      ) : null}
      <ScheduleTitle className={s.titleMobile} />
      {isDateAndLocationVisible() ? (
        <div className={s.dateLocationMobile}>
          <span data-hook={DH.EVENT_TITLE}>{`${eventTitle} | `}</span>
          <span>{formattedEventDateAndLocation}</span>
        </div>
      ) : null}
    </div>
  )
}
